<script lang="ts" setup>
import type { ContentTypeTeamStory } from '~~/types/storyblok/stories'

const props = defineProps<{
  story: ContentTypeTeamStory
}>()

const photo = computed(() => {
  return {
    _uid: 'hero',
    component: 'MediaImage',
    asset: props.story.content.photo,
  }
})

const emit = defineEmits(['activate'])

function openBio() {
  emit('activate', props.story)
}
</script>

<template lang="pug">
article(
  v-editable="story.content"
  @click="openBio"
  class="blok-article flex h-full bg-grey-100 relative rounded cursor-pointer transition-all ease-in-out duration-500 hover:-translate-y-6"
)
  div(class="basis-2/5 grow-0 p-9")
    MediaImage(
      :blok="photo"
      :with-overlay="false"
      :object-cover="true"
      :grayscale="true"
      :width="320"
      aspect="team-member"
    )
  div(class="flex flex-col justify-between pt-24 px-18 basis-3/5 grow-0")
    div
      h3(class="text-md font-sans font-bold mb-3") {{ story.name }}
      p(v-if="props.story.content?.role" class="text-base mb-0") {{ props.story.content.role }}
      p(v-if="props.story.content?.qualifications" class="text-sm text-grey-500") {{ props.story.content.qualifications }}
    div
      a(
        :href="story.full_slug"
        @click.prevent="openBio"
        class="button button--sm button--theme-grey-100 button--outline"
      ) View Bio
</template>
